"use client";
import { j as e } from "./jsx-runtime-CJ-St4mQ.mjs";
import a from "./Button.js";
import { t as c } from "./tv.config-BuYIgndg.mjs";
import { forwardRef as m } from "react";
const i = c({
  base: ["Icon__button", "!p-0", "border-none"],
  variants: {}
}), d = m(
  (t, o) => {
    const { children: s, className: r, ...n } = t;
    return /* @__PURE__ */ e.jsx(
      a,
      {
        ...n,
        ref: o,
        className: i({ class: r }),
        children: s
      }
    );
  }
);
export {
  d as default
};
